import React from "react";
import { useFormikContext } from "formik";
import PricingEditor from "../components/PricingEditor";

export default function PricingTab({
    meta,
}) {
    const {
        values,
        setFieldValue,
    } = useFormikContext();

    return (
        <PricingEditor
            value={values.prices || []}
            pricingUiMode={
                values.pricingUiMode ||
                "SIMPLE"
            }
            pricingMode={
                meta?.pricingMode ||
                "FIXED"
            }
            onChange={(nextPrices) =>
                setFieldValue(
                    "prices",
                    nextPrices
                )
            }
            onChangeUiMode={(nextMode) =>
                setFieldValue(
                    "pricingUiMode",
                    nextMode
                )
            }
        />
    );
}